import { get, post, put, del, getRequest, putRequest } from "./api_helper";

//auth
export const userAccountLogin = (data) => post("/auth/login", data);
export const verifyUserAPI = (data) => get("auth/verify", data);
//main
export const editPdfFile = (data) => post("/pdf/delete-text-from-pdf", data, {
    responseType: "arraybuffer", // So you get binary PDF content
  });